export default __webpack_public_path__ + "static/media/down-outlined.e8a0f712.svg";